import { Question } from '@estercare/ester-shared'
import { DynamicScreeningOptions } from './DynamicScreeningOptions'

type ScreeningQuestionProps = Question & {
  showValidation: boolean
}

export const ScreeningQuestion = ({
  title,
  description,
  type,
  options,
  metadata,
  id,
  showValidation,
}: ScreeningQuestionProps) => {
  return (
    <DynamicScreeningOptions
      type={type}
      questionId={id}
      options={options}
      metadata={metadata}
      title={title}
      description={description}
      showValidation={showValidation}
    />
  )
}
